import { mapActions } from 'vuex'
import router from '@/router'
import { cloneDeep } from 'lodash'
import tagAddEditContent from '@/components/pages/main-pages/settings/tags/tag-add-edit-content/tag-add-edit-content.vue'

export default {
  components: {
    tagAddEditContent
  },
  data() {
    return {
      tag: { name: null }
    }
  },
  methods: {
    ...mapActions('tag', ['createTag', 'getTags']),
    ...mapActions('competitionMechanic', ['getMechanicList']),
    onCreateTag: async function () {
      try {
        const newTag = cloneDeep(this.tag)
        await this.createTag(newTag)
        this.$notify({
          text: 'Tag created',
          type: 'success'
        })
        this.getTags()
        router.push({ name: 'tags' })
      } catch (e) {
        this.$notify({
          text: 'Error while creating tag',
          type: 'error'
        })
      }
    },
    cancel: function () {
      router.push({ name: 'tags' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/tags/tag-add/tag-add.js